<app-empty-table *ngIf="tableType && itemList.length === 0" [type]="tableType"></app-empty-table>
<div class="tab-pane fade show active" role="tabpanel">
  <div class="clearfix box-holder" [class.clickable-box]="onEdit.observers.length > 0" [ngClass]="holderClass">
    <ng-container *ngFor="let item of itemList; let i = index">
      <div (click)="edit(item)" class="col-sm-12 date" *ngIf="item.uiTimeCaption">
        <i class="fas fa-calendar-alt"></i> {{item.uiTimeCaption}}
      </div>

      <div (click)="edit(item)" class="col-sm-12 box" [ngClass]="item.uiBoxClass" *ngIf="i < showIndex">
        <div class="avater">
          <img *ngIf="item.uiUserImage" src="{{item.uiUserImage}}" alt="">
          <i [ngClass]="item.uiMainIcon"></i>
        </div>
        <div class="box-content">
          <h4>
            <small *ngIf="preUserName">{{preUserName}} </small>
            {{item[userNameKey]}}  <span class="badge" *ngIf="badgeKey">{{item[badgeKey]}}</span><br />
            <small>{{item[timeKey] | epoch: timeFormat}}</small>
          </h4>
          <p>{{item[conentKey]}}</p>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row no-margin" *ngIf="isMoreAvailable()">
    <div class="col-sm-12 btn-holder-btm">
      <button type="button" class="btn btn-outline-success text-uppercase" (click)="showMore()">
        Show More
      </button>
    </div>
  </div>
</div>
